var exports = {};
Object.defineProperty(exports, "__esModule", {
  value: true
});
// https://mathiasbynens.be/notes/javascript-encoding
// https://github.com/bestiejs/punycode.js - punycode.ucs2.decode
function ucs2length(str) {
  const len = str.length;
  let length = 0;
  let pos = 0;
  let value;
  while (pos < len) {
    length++;
    value = str.charCodeAt(pos++);
    if (value >= 55296 && value <= 56319 && pos < len) {
      // high surrogate, and there is a next character
      value = str.charCodeAt(pos);
      if ((value & 64512) === 56320) pos++; // low surrogate
    }
  }
  return length;
}
exports.default = ucs2length;
ucs2length.code = "require(\"ajv/dist/runtime/ucs2length\").default";
//# sourceMappingURL=ucs2length.js.map
export default exports;
export const __esModule = exports.__esModule;